import Field, { FieldProps } from '../field/Field';
import React from 'react';

interface EmailFieldProps extends Omit<FieldProps, 'type'> {}

const EmailField = (props: EmailFieldProps) => (
  <Field
    aria-label="E-mail address field"
    aria-roledescription="Field where users can input their e-mail address"
    type="email"
    {...props}
  />
);

export default EmailField;
